import FileChipFilename from '../FileChip/FileChipFilename';
import ThumbnailLoadingPlaceholder from './ImagePreview/ImagePreviewThumbnail/ThumbnailLoadingPlaceholder';

type ImagePreviewLoadingStateProps = {
  imageFilename: string;
};

const ImagePreviewLoadingState = ({
  imageFilename,
}: ImagePreviewLoadingStateProps) => (
  <>
    <ThumbnailLoadingPlaceholder />
    <FileChipFilename>{imageFilename}</FileChipFilename>
  </>
);

export default ImagePreviewLoadingState;
